import './index.css';
import React, { CSSProperties } from 'react';
import { isDesktopBrowser } from '../../utilities/helper';

interface Props {
  children?: any;
  className?: string | undefined;
  style?: CSSProperties | undefined;
  onPress?: React.MouseEventHandler;
}
const Text = ({ onPress, className, style, children }: Props) => {
  if (onPress && isDesktopBrowser) {
    className = `${className} text-hover-container`;
  }
  return (
    <p onClick={onPress} style={style} className={`text-container ${className}`}>
      {children}
    </p>
  );
};
Text.defaultProps = {
  children: '',
  className: {},
  style: {},
  onPress: undefined
};
export default React.memo(Text);
